export enum CssColorClass {
  brand1 = 'brand1',
  warning = 'warning',
  danger = "danger"
}
